import * as localforage from 'localforage';
import env from '../../../config/env';
import * as types from '../../types/base-post.types';
import { errorGQLHandler, currentDateFormat, currentDate } from '../../../helpers/helpers';
import NOTICIA_POST from '../../../graphql/revista/queries/NoticiaPost.gql';
import TERMO_DE_ACEITO from '../../../graphql/revista/mutations/TermoDeAceito.gql';
import TERMO_DE_ACEITO_FALANDO_DE_GENTE from '../../../graphql/revista/mutations/TermoDeAceiteFalandoDeGente.gql';
import REGISTER_LOG_TERMO_DE_ACEITO from '../../../graphql/revista/mutations/RegistarLogTermoAceito.gql';

export default {
  namespaced: true,
  state: {
    termo: false,
    lido: null,
    carregando: true,
    data: {},
  },
  getters: {
    termo: state => state.termo,
    lido: state => state.lido,
    carregando: state => state.carregando,
    postData: state => state.data,
  },
  mutations: {
    [types.POST](state, payload) {
      state.carregando = false;
      state.data = payload || {};
    },
    [types.TERMO_DE_ACEITO](state, payload) {
      state.termo = payload !== '';
      state.lido = payload !== '' ? payload : null;
    },
  },
  actions: {
    async getPost({ commit, state, rootGetters, dispatch }, payload) {
      try {
        
        state.data = {};
        state.termo = false;
        state.carregando = true;
        const uf = await rootGetters['user/uf'];
        const ufs = await rootGetters['uf/ufs'];
        const ufId = ufs.filter(uf => uf.sigla === rootGetters['user/uf']).map(item => item.id);
        const query = await env.apolloRevista.query({
          query: NOTICIA_POST,
          variables: {
            modulo: env.revista.modulo,
            canal: rootGetters['home/canal'],
            slug: payload,
            uf: [uf],
            ufs_favoritos: ufId,
          },
          fetchPolicy: 'no-cache',
        });

        const [data] = query.data.noticias.data;

        commit(types.POST, data);
        if (data) await dispatch('getTermoDeAceito', data);
      } catch (err) {
        console.log(err);
        errorGQLHandler(err);
      }
    },
    async getTermoDeAceito({ commit }, payload) {
      const { lido } = payload;
      await commit(types.TERMO_DE_ACEITO, lido);
    },
    registerTermos({ commit, dispatch }, payload) {
      let query = payload.falandoDeGente? TERMO_DE_ACEITO_FALANDO_DE_GENTE : TERMO_DE_ACEITO      
      env.apolloRevista
        .mutate({
          mutation: query,
          variables: {
            noticiaId: payload.id,
            canalId: env.revista.canal,
            uf: env.revista.uf,
          },
        })
        .then(({ data }) => {
          if (data.response.id) console.log(data.response.id);
          dispatch('registerLog', {
            logName: `${currentDate()}.${payload.id}.${env.revista.uf}.${env.token}`,
            id: data.response.id,
          });
          dispatch('notificacoes/getNotificacaoHeader', {}, { root: true });
          commit(types.TERMO_DE_ACEITO, currentDateFormat());
        });
    },
    registerLog(ctx, payload) {
      localforage.getItem(payload.logName).then(r => {
        const s = Object.assign(r, { acao: 'termo', termo_id: payload.id });
        env.apolloRevista.mutate({
          mutation: REGISTER_LOG_TERMO_DE_ACEITO,
          variables: s,
        });
      });
    },
  },
};
